import React, { useMemo } from 'react'
import { localize } from 'utils/localize'

const withLocalization =
  (PageComponent) =>
  ({ data, pageContext, ...rest }) => {
    const localized = useMemo(
      () => localize(data, pageContext.language),
      [data, pageContext.language]
    )

    return (
      <PageComponent data={localized} pageContext={pageContext} {...rest} />
    )
  }

export default withLocalization
